import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import React from "react";
import { useControlBarCreateFolderButtonHook } from "./use-control-bar-create-folder-button-hook";
import { useI18N } from "@src/language/language-context";

export const ControlBarCreateFolderButton = () => {
  const {
    createFolderHandler,
    getCreateFolderIcon,
    handleCreateFolderIsDisabled,
  } = useControlBarCreateFolderButtonHook();
  const i18n = useI18N();
  const tooltip = i18n("modules.machineStructurePanelControlBar.createFolder");

  return (
    <IconButton
      key={tooltip}
      tooltip={tooltip}
      tooltipPosition="bottom"
      fun={createFolderHandler}
      icon={getCreateFolderIcon()}
      disabled={handleCreateFolderIsDisabled()}
    />
  );
};
